var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":"Código do pedido"}},[_c('b-form-select',{attrs:{"options":_vm.selectPedidos,"required":""},model:{value:(_vm.value.idPedido),callback:function ($$v) {_vm.$set(_vm.value, "idPedido", $$v)},expression:"value.idPedido"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }